import { useEffect } from 'react';
import { useUnit } from 'effector-react';
import { useTranslation } from 'react-i18next';
import { $corporateTravelContactsStore } from '@lib/store';
import { cn, PaletteUtils } from '@shared/utils';
import { View } from '@widgets';
import { Icon, Text } from '@shared/widgets';
import ClockIcon from '@assets/icons/clock.svg';
import MailIcon from '@assets/icons/mail.svg';
import PhoneIcon from '@assets/icons/phone.svg';
import ChatIcon from '@assets/icons/chat.svg';

interface TravelTeamProps {
  className?: string;
}

export const TravelTeam = (props: TravelTeamProps) => {
  const corporateTravelContactsStore = useUnit($corporateTravelContactsStore.store);

  const { t } = useTranslation('travel');

  useEffect(() => {
    $corporateTravelContactsStore.events.getCorporateTravelContacts();
  }, []);

  const contacts = [
    { icon: <MailIcon className='size-5' />, label: t('travelTeam.contacts.email'), value: corporateTravelContactsStore.data?.email || '-' },
    {
      icon: <PhoneIcon className='size-5' />,
      label: t('travelTeam.contacts.telephone'),
      value: corporateTravelContactsStore.data?.telephoneNumber || '-',
    },
    {
      icon: <ChatIcon className='size-5' />,
      label: t('travelTeam.contacts.mobileWhatsApp'),
      value: corporateTravelContactsStore.data?.mobileAndWhatsApp || '-',
    },
  ];
  return (
    <section
      className={cn(
        'flex h-fit flex-col gap-6 bg-white p-6 dark:bg-soft-black',
        PaletteUtils.isVcfcPalette && 'rounded-xl dark:border dark:border-gray-black',
        props.className,
      )}
    >
      <div className='flex flex-col gap-2'>
        <Text tag='h2' weight='semibold' size='2xl'>
          {t('travelTeam.title')}
        </Text>
        <Text tag='p' color='gray'>
          {t('travelTeam.description')}
        </Text>
      </div>
      <Text className='flex w-fit items-center gap-2 rounded-full bg-dark-emerald px-3 py-1' weight='semibold' size='sm' color='green'>
        <Icon className='shrink-0' icon={<ClockIcon className='size-4' />} color='green' />
        {t('travelTeam.available')}
      </Text>
      <View
        loading={corporateTravelContactsStore.loading}
        noData={!corporateTravelContactsStore.data}
        error={corporateTravelContactsStore.error}
        onRefresh={() => $corporateTravelContactsStore.events.getCorporateTravelContacts()}
      >
        <ul className='flex flex-col gap-4'>
          {contacts.map((contact, idx) => (
            <li key={idx} className='flex items-center gap-2 border-b border-gray-black pb-4 last:border-b-0 last:pb-0'>
              <Icon className='flex size-10 shrink-0 items-center justify-center rounded-md bg-ghost-white dark:bg-light/5' icon={contact.icon} />
              <div className='flex flex-col'>
                <Text color='gray'>{contact.label}</Text>
                <Text className='break-words' weight='medium'>
                  {contact.value}
                </Text>
              </div>
            </li>
          ))}
        </ul>
      </View>
    </section>
  );
};
